import React, { useRef, useState } from "react";
import { logResponse } from "../utils/logger";
import { useLocation } from "react-router-dom";
import { fetchRegister } from "../api";
import SubmitButton from "../components/SubmitButton";

const Signup = () => {
  const formRef = useRef();
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const isSubmittingRef = useRef(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const customerType = params.get("customer_type") || "new";

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const isValidPassword = (value) =>
    /^[a-zA-Z0-9]{8,}$/.test(value) && /[a-zA-Z]/.test(value) && /\d/.test(value);

  const handleSubmit = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setMessage("");
    setIsError(false);

    const formData = new FormData(formRef.current);
    const data = Object.fromEntries(formData.entries());

    const email = data.email?.trim();
    const password = data.password?.trim();
    const passwordConfirm = data["password-confirm"]?.trim();

    if (!email || !isValidEmail(email)) {
      setMessage("有効なメールアドレスを入力してください。");
      setIsError(true);
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }

    if (!password || !isValidPassword(password)) {
      setMessage("半角英数字8文字以上で、英字と数字を含めてください。");
      setIsError(true);
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }

    if (password !== passwordConfirm) {
      setMessage("パスワードが一致しません。再度ご確認ください。");
      setIsError(true);
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }

    delete data["password-confirm"];
    if (customerType) {
      data.customer_type = customerType;
    }

    try {
      const res = await fetchRegister(data);
      logResponse("req:", data);
      logResponse("res:", res);

      if (res.detail) {
        const detail = Array.isArray(res.detail)
          ? res.detail.map((d) => d.msg).join(" / ")
          : typeof res.detail === "object"
          ? res.detail.msg || JSON.stringify(res.detail)
          : res.detail;

        setMessage(detail);
        setIsError(true);
      } else if (res.message) {
        setMessage("ご登録メールアドレス宛てに認証用URLをお送りしましたので、ご確認ください。");
        setIsError(false);
      } else {
        setMessage("予期せぬ応答です。");
        setIsError(true);
      }
    } catch (err) {
      console.error("API呼び出しエラー:", err);
      setMessage("通信エラーが発生しました。時間を置いて再度お試しください。");
      setIsError(true);
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section form-section section-block">
      <form className="login-form" ref={formRef} noValidate>
        <div className="form-group">
          <label htmlFor="email">ご登録のメールアドレス</label>
          <div className="overlap-group-wrapper">
            <div className="overlap-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="example@gmail.com"
                required
                autoComplete="email"
                aria-describedby="email-error"
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="password">パスワード</label>
          <div className="group-2 password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              required
              autoComplete="new-password"
              aria-describedby="password-error"
              placeholder="半角英数字8文字以上"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "パスワードを隠す" : "パスワードを表示する"}
            >
              <i className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
            </button>
          </div>
        </div>


        <div className="form-group">
          <label htmlFor="password-confirm">パスワード（再入力）</label>
          <div className="group-2 password-wrapper">
            <input
              type={showPasswordConfirm ? "text" : "password"}
              name="password-confirm"
              required
              autoComplete="new-password"
              aria-describedby="password-error"
              placeholder="半角英数字8文字以上"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPasswordConfirm((prev) => !prev)}
              aria-label={showPasswordConfirm ? "パスワードを隠す" : "パスワードを表示する"}
            >
              <i className={`fa-solid ${showPasswordConfirm ? "fa-eye" : "fa-eye-slash"}`}></i>
            </button>
          </div>
        </div>

        {message && (
          <div className="form-group">
            <p style={{ color: isError ? "red" : "green", fontWeight: "bold" }}>
              {message}
            </p>
          </div>
        )}

        <div className="btn-green mb0">
          <SubmitButton
            type="button"
            onClick={handleSubmit}
            isSubmitting={isSubmitting}
            label="新規登録"
            className="btn-green"
            wrap={false}
          />
        </div>
      </form>
    </section>
  );
};

export default Signup;
